/**
 * CostsPage — Sprint 21.7.6 Issue 13 restoration.
 *
 * Operator-tier cost dashboard (Sprint 3.5 infrastructure restored to
 * nav). Surfaces Anthropic + Finnhub + Twelve Data + NewsAPI spend.
 *
 * Per ADR-036 this is operator data, not portfolio data. P17 does NOT
 * apply — USD amounts here are KORINTH infrastructure spend, not
 * Kamal's holdings.
 */
import { useEffect } from 'react';
import { DollarSign } from 'lucide-react';
import CostDashboard from '../../components/macro-radar/CostDashboard.jsx';
import { usePage } from '../../contexts/PageContext.jsx';

export default function CostsPage() {
  const { setPage } = usePage();
  useEffect(() => { setPage('system-costs'); }, []);

  return (
    <div className="space-y-4">
      <div className="flex items-center gap-3">
        <DollarSign className="w-6 h-6 text-korinth-accent" />
        <h1 className="text-2xl font-bold text-white">System Costs</h1>
        <span className="text-xs font-mono text-korinth-muted">
          Anthropic + Finnhub + Twelve Data + NewsAPI spend · operator view
        </span>
      </div>

      <div className="text-[11px] font-mono text-korinth-muted bg-korinth-surface border border-korinth-border rounded-lg p-3">
        <span className="text-korinth-accent font-bold">Note:</span>{' '}
        USD amounts on this page are KORINTH operational spend (API calls to Anthropic, Finnhub, Twelve Data, NewsAPI).
        Not Kamal's portfolio dollars. P17 does not apply here — this is operator-tier data per ADR-036.
        Cross-check within ±10% against Anthropic Console's billing page.
      </div>

      <CostDashboard />
    </div>
  );
}
